// extracted by mini-css-extract-plugin
module.exports = {"tile":"toggle-tile_tile__RKZUF","label":"toggle-tile_label__jErDW","check":"toggle-tile_check__rlH3l","glyph":"toggle-tile_glyph__A_y4q"};